<script>
import _ from "lodash";

export default {
    name: "VDataTableCustomHeader",
    components: {},
    inheritAttrs: false,
    props: {
        headers: {
            type: Array,
            required: true,
        },
        items: {
            type: Array,
        },
        value: {
            type: Object,
        },
        filteredItems: {
            type: Array,
        },
    },
    data() {
        return {
            isMounted: false,
        };
    },
    mounted() {
        this.isMounted = true;
    },
    computed: {
        filters: {
            get() {
                return this.value;
            },
            set(v) {
                this.$emit('input', v);
            },
        },
        hasFilterColumn() {
            return (_.filter(this.headers, v => !!v.filterComponent).length > 0);
        },
        filteredItemsLocal() {
            return this.isMounted ? _.reduce(
                this.$refs.filterComponents,
                (result, filterComponent) => {
                    return filterComponent.filterItems(result);
                },
                this.items
            ) : this.items;
        },
    },
    watch: {
        filteredItemsLocal: {
            handler(v) {
                this.$emit('update:filtered-items', v);
            },
            immediate: true,
        },
    },
}
</script>

<template>
    <thead v-if="hasFilterColumn" class="v-data-table-header">
    <tr>
        <td :colspan="headers.length">
            <v-container fluid class="pt-8">
                <v-row>
                    <template v-for="header in headers">
                        <v-col :cols="12" :sm="3" :key="header.value" class="ma-0 pa-1" v-if="header.filterComponent">
                            <component
                                v-model="filters[header.value]"
                                v-bind="header.filterComponentProps"
                                ref="filterComponents"
                                :is="header.filterComponent"
                                :header="header"
                                :items="items"
                                :class="header.filterComponentClass"
                                dense
                            ></component>
                        </v-col>
                    </template>
                </v-row>
            </v-container>
        </td>
    </tr>
    </thead>
</template>

<style scoped lang="scss">
thead {
    td {
        border-bottom: thin solid rgba(0, 0, 0, 0.12);
    }
}
</style>